export const platforms = [
  { key: "douyin", name: "抖音电商" },
  { key: "pdd", name: "拼多多" },
  { key: "taobao", name: "淘宝" },
  { key: "jd", name: "京东" },
  { key: "local", name: "本地商城" },
];

export const priceProducts = [
  {
    name: "邵店黄姜干货",
    town: "邵店镇",
    spec: "500g",
    cost: 21,
    lower: 26,
    upper: 40,
    prices: { douyin: 39.9, pdd: 34.8, taobao: 38.6, jd: 42.8, local: 31.9 },
  },
  {
    name: "上蔡花生礼盒",
    town: "黄埠镇",
    spec: "2kg",
    cost: 26.5,
    lower: 32,
    upper: 46,
    prices: { douyin: 42.6, pdd: 36.6, taobao: 39.9, jd: 44.8, local: 36.8 },
  },
  {
    name: "朱里红薯粉条",
    town: "朱里镇",
    spec: "1kg",
    cost: 16.8,
    lower: 22,
    upper: 34,
    prices: { douyin: 31.8, pdd: 25.4, taobao: 29.9, jd: 33.6, local: 24.8 },
  },
  {
    name: "黄姜茶组合",
    town: "邵店镇",
    spec: "30袋",
    cost: 25.5,
    lower: 33,
    upper: 56,
    prices: { douyin: 49.9, pdd: 43.8, taobao: 48.6, jd: 52.8, local: 45.8 },
  },
  {
    name: "小磨香油",
    town: "蔡都街道",
    spec: "500ml",
    cost: 30.8,
    lower: 38,
    upper: 58,
    prices: { douyin: 54.8, pdd: 46.2, taobao: 49.9, jd: 56.8, local: 43.6 },
  },
  {
    name: "羊肚菌干品",
    town: "无量寺乡",
    spec: "250g",
    cost: 92,
    lower: 112,
    upper: 146,
    prices: { douyin: 138, pdd: 124, taobao: 128, jd: 145, local: 119 },
  },
  {
    name: "红薯干",
    town: "朱里镇",
    spec: "500g",
    cost: 12.8,
    lower: 16,
    upper: 26,
    prices: { douyin: 19.8, pdd: 17.2, taobao: 18.9, jd: 22.6, local: 16.8 },
  },
  {
    name: "花生油礼盒",
    town: "黄埠镇",
    spec: "2L",
    cost: 43,
    lower: 52,
    upper: 72,
    prices: { douyin: 62.8, pdd: 55.6, taobao: 58, jd: 68, local: 54.8 },
  },
  {
    name: "菌菇礼盒",
    town: "无量寺乡",
    spec: "1kg",
    cost: 48,
    lower: 58,
    upper: 86,
    prices: { douyin: 82, pdd: 69.8, taobao: 76.8, jd: 88, local: 65.8 },
  },
  {
    name: "黄姜粉",
    town: "邵店镇",
    spec: "300g",
    cost: 18.6,
    lower: 24,
    upper: 38,
    prices: { douyin: 36.8, pdd: 30.8, taobao: 34.6, jd: 39.8, local: 28.4 },
  },
];

export function formatPrice(value, digits = 2) {
  return Number(value).toFixed(digits);
}

export function average(values) {
  return values.reduce((sum, value) => sum + Number(value), 0) / values.length;
}

export function productPrices(product) {
  return platforms.map((platform) => product.prices[platform.key]);
}

export function productAverage(product) {
  return average(productPrices(product));
}

export function platformAverage(platformKey) {
  return average(priceProducts.map((product) => product.prices[platformKey]));
}

export function overallAverage() {
  return average(priceProducts.flatMap(productPrices));
}

export function priceSpread(product) {
  const prices = productPrices(product);
  return Math.max(...prices) - Math.min(...prices);
}

export function lowestPlatform(product) {
  return platforms.reduce((lowest, platform) =>
    product.prices[platform.key] < product.prices[lowest.key] ? platform : lowest
  );
}
